<template>
  <div class="salon-cars__contacts-btns">
    <button @click="call()" class="main-basic-info-btn-phone contacts-phone-btn">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" width="17px" height="17px">
        <path fill="#FFF" fill-rule="nonzero"
              d="M8.1568334 10.4553077c-1.4607747-1.1986508-2.4361454-2.67773-2.9489271-3.5193292l-.3825014-.7195987c.1337417-.1431975 1.1536407-1.2330371 1.5956178-1.8243547.5554217-.7425229-.249861-1.413133-.249861-1.413133S3.9052616.7174083 3.3888611.2688171C2.8724605-.18040219 2.2780178.0690943 2.2780178.0690943 1.1926641.7689091.0675025 1.3773414.0000023 4.3034688c-.0025175 2.7395938 2.0814938 5.5652317 4.335121 7.7527615 2.2572462 2.4704705 5.3564361 4.9465935 8.3527235 4.9437673 2.931934-.0667313 3.5414817-1.1893869 4.2427606-2.2724749 0 0 .2501757-.5927307-.1995112-1.1085243-.4500017-.5156365-2.7165312-2.7772773-2.7165312-2.7772773s-.6715409-.8037587-1.4157745-.2490255c-.5546349.413734-1.5506176 1.3339976-1.7905661 1.5571156.000472.000785-1.6656356-.8855634-2.651391-1.6945035z"></path>
      </svg>
      <a v-if="showPhoneNum" class="company-phone-link" :href="`tel:${company.phone}`">{{ company.phone }}</a>
      <span v-else>Sýna símanumer</span>
    </button>

    <a v-if="$store.state.isApp" href="javascript:void(0);" @click.prevent="webSite()"
       class="main-basic-info-btn-email contacts-email-btn">
      <span> {{ showSite && company.site ? company.site : 'Vefsíða' }}</span>
    </a>

    <a v-else :href="getWebSiteUrl" target="_blank" @click="clickSite"
       class="main-basic-info-btn-email contacts-email-btn">
      <span>{{ showSite && company.site ? company.site : 'Vefsíða' }}</span>
    </a>

  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  data: function () {
    return {
      showPhoneNum: false,
      showSite: false,
    }
  },
  props: {
    company: {
      type: Object
    }
  },
  computed: {
    ...mapState({
      isApp: state => state.isApp
    }),
    getWebSiteUrl() {
      let url = this.company.site;
      if(url.search("http") === -1){
        url = "https://"+url;
      }
      return url;

     /* if (this.$route.name == 'Car') {
        return this.$store.state.api + '/old-cars/view-site?id=' + this.$route.params.id;
      } else {
        return this.$store.state.api + '/new-cars/view-site?id=' + this.$store.state.car_id;
      }*/
    }
  },
  methods: {
    ...mapActions({
      "saveStat": "SAVE_STATISTIC"
    }),
    call() {
      this.showPhoneNum = true;
      let data = {
        key: "call",
        id: ['Car', 'k7Car'].includes(this.$route.name)  ? this.$route.params.id : this.$store.state.car_id,
        is_old: this.$route.name == 'DealerCar' ? 0 : 1
      };

      this.saveStat(data);
      /*let api = this.$store.state.api;
      this.$http
          .post(`${api}/new-cars/save-stat`, {
              key: "call",
              id: this.$route.name == 'Car' ? this.$route.params.id : this.$store.state.car_id,
              is_old:this.$route.name == 'DealerCar' ? 0 : 1
          })
          .then(function (d) {
              console.log(d.data);
          });

       */
    },
    clickSite() {
      let data = {
        key: "view_company_site",
        id: ['Car', 'k7Car'].includes(this.$route.name) ? this.$route.params.id : this.$store.state.car_id,
        is_old: this.$route.name == 'DealerCar' ? 0 : 1
      };

      this.saveStat(data);

      this.showSite = true;
    },
    webSite() {
      this.showSite = true;
      let data = {
        key: "view_company_site",
        id: ['Car', 'k7Car'].includes(this.$route.name) ? this.$route.params.id : this.$store.state.car_id,
        is_old: this.$route.name == 'DealerCar' ? 0 : 1
      };

      this.saveStat(data);
      return window.open(this.getWebSiteUrl, '_system', 'location=yes');
      //return window.open(url, '_blank', 'location=yes');
    }
  }
}
</script>
